export const siteInfo = {
  name: '爆料网',
  tagline: '聚合全网黑料，每日实时更新',
  slogan: '你身边的吃瓜第一站，不错过任何一个瓜',
  intro: '爆料网是国内领先的吃瓜黑料聚合平台，致力于为广大吃瓜群众提供最新、最全、最热门的黑料合集。我们实时追踪黑料网爆料、爆料黑料网、911爆料网吃瓜黑料等主流渠道，每日更新海量独家内幕与网红黑料，涵盖娱乐八卦、社会热点、网红争议等多个领域。无论你是想了解最新吃瓜黑料曝光，还是寻找黑料汇总合集，爆料网都能满足你一站式吃瓜需求。',
  stats: [
    { label: '每日更新', value: '200+', desc: '条新鲜黑料' },
    { label: '话题覆盖', value: '50+', desc: '个分类频道' },
    { label: '全天候', value: '7×24', desc: '小时不间断追踪' },
  ],
};

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '最新快讯', href: '#updates' },
  { label: '专题合集', href: '#index' },
  { label: '热度榜单', href: '#ranking' },
  { label: '移动入口', href: '#app' },
];

export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20avatar%20portrait%20with%20warm%20tone%20minimal%20background%20clean%20stylish%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '终于有人把全网黑料汇总到一起了！每天上班摸鱼必刷，爆料速度比微博还快，牛啊！',
    likes: 238,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20avatar%20portrait%20casual%20style%20warm%20tone%20minimal%20background%20clean%20modern%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '911爆料网吃瓜黑料那个专题做得太详细了，时间线清晰，证据链完整，比那些断章取义的营销号强多了。',
    likes: 186,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20avatar%20portrait%20elegant%20warm%20tone%20minimal%20background%20clean%20stylish%20modern%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '八卦研究员',
    time: '8小时前',
    content: '每天睡前必刷一遍黑料合集，已经成为习惯了。小编整理得很用心，独家内幕质量很高，推荐给了好多朋友。',
    likes: 421,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20portrait%20trendy%20style%20warm%20tone%20minimal%20background%20clean%20modern%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '瓜田守望者',
    time: '12小时前',
    content: '黑料网爆料的几个大瓜都是在这里先看到的，比其他平台快半天以上。这更新速度真的服气，吃瓜就认准爆料网了。',
    likes: 567,
  },
];

export const aboutContent = {
  title: '关于爆料网',
  paragraphs: [
    '爆料网创立于对吃瓜文化的深刻理解之上。我们深知，在信息爆炸的时代，真正的黑料往往被淹没在噪音之中。因此，我们组建了一支专业的黑料追踪团队，每日监控黑料网爆料、爆料黑料网、911爆料网吃瓜黑料等数百个信息源，确保你不错过任何一个值得关注的瓜。',
    '我们的编辑团队坚持「快、准、全」三大原则：第一时间捕获热点黑料，多方核验信息真实性，全面整理事件来龙去脉。从网红黑料到娱乐圈内幕，从社会热点到行业潜规则，爆料网为你呈现最有价值的吃瓜黑料合集。',
    '每天凌晨与傍晚两次固定更新，突发黑料随时加更。我们相信，每一个吃瓜群众都值得拥有一个专业、高效、靠谱的黑料汇总平台。',
  ],
};

export const appEntry = {
  title: '随时随地吃瓜',
  subtitle: '移动端访问更便捷',
  description: '爆料网移动端适配完美，无论你在通勤路上、午休间隙还是睡前时光，打开手机浏览器即可畅享最新吃瓜黑料。无需下载，即点即看，流量消耗极低。将爆料网添加到手机主屏幕，像原生APP一样快速访问，黑料爆料永不错过。',
  features: ['免安装即用', '极速加载体验', '消息推送提醒', '夜间阅读模式'],
};

export const rankingItems = [
  { rank: 1, title: '某顶流网红私生活混乱遭实锤，多段聊天记录与视频曝光', heat: '987万', tag: '爆', trend: 'up' },
  { rank: 2, title: '知名电商主播偷税漏税被查，涉案金额高达数千万', heat: '856万', tag: '热', trend: 'up' },
  { rank: 3, title: '娱乐圈某夫妻疑似婚变，双方已分居数月互删动态', heat: '743万', tag: '热', trend: 'up' },
  { rank: 4, title: '某综艺节目录制现场发生冲突，嘉宾当场罢录离场', heat: '621万', tag: '新', trend: 'up' },
  { rank: 5, title: '电竞圈知名选手被爆代打丑闻，职业生涯面临危机', heat: '508万', tag: '新', trend: 'down' },
];

export const contactInfo = {
  title: '联系我们',
  subtitle: '欢迎投稿爆料',
  description: '你有第一手黑料内幕？发现了不为人知的真相？爆料网欢迎每一位有料的爆料人。我们承诺严格保护爆料人隐私，所有投稿均采用匿名处理，绝不泄露信息来源。你的每一次爆料，都是对真相的捍卫。',
  ways: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@baoliao.wang' },
    { icon: 'ri-wechat-line', label: '微信客服', value: 'baoliaowang888' },
    { icon: 'ri-shield-check-line', label: '隐私承诺', value: '严格保护爆料人信息' },
  ],
};

export const topicItems = [
  { id: 1, name: '网红黑料', count: 1286, hot: true },
  { id: 2, name: '娱乐圈八卦', count: 987, hot: true },
  { id: 3, name: '社会热点', count: 756, hot: true },
  { id: 4, name: '吃瓜黑料', count: 2341, hot: false },
  { id: 5, name: '独家内幕', count: 543, hot: true },
  { id: 6, name: '黑料合集', count: 1892, hot: false },
  { id: 7, name: '911爆料', count: 421, hot: false },
  { id: 8, name: '每日黑料', count: 3156, hot: false },
  { id: 9, name: '电竞圈', count: 678, hot: false },
  { id: 10, name: '直播圈', count: 534, hot: false },
  { id: 11, name: '黑料曝光', count: 1654, hot: true },
];

export const mediaCards = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=dramatic%20news%20studio%20scene%20with%20warm%20red%20and%20dark%20lighting%20cinematic%20atmosphere%20breaking%20news%20style%20editorial%20photography%20high%20contrast%20moody&width=640&height=360&seq=media-01&orientation=landscape',
    title: '深度起底：某带货主播背后的资本局中局',
    duration: '15:28',
    views: '128万',
    badge: '深度调查',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=entertainment%20industry%20behind%20scenes%20dramatic%20lighting%20warm%20amber%20tones%20cinematic%20documentary%20style%20mysterious%20atmosphere%20editorial&width=640&height=360&seq=media-02&orientation=landscape',
    title: '娱乐圈潜规则大揭秘：新人出道背后的真相',
    duration: '22:15',
    views: '96万',
    badge: '独家揭秘',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=social%20media%20scandal%20investigation%20concept%20dramatic%20red%20and%20dark%20tones%20cinematic%20lighting%20moody%20atmosphere%20editorial%20photography&width=640&height=360&seq=media-03&orientation=landscape',
    title: '网红圈黑料合集：2024年度十大翻车事件',
    duration: '18:42',
    views: '203万',
    badge: '年度盘点',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=investigative%20journalism%20scene%20dark%20warm%20lighting%20dramatic%20atmosphere%20documents%20and%20evidence%20cinematic%20moody%20editorial%20style&width=640&height=360&seq=media-04&orientation=landscape',
    title: '黑料网爆料追踪：三个月内五大未解悬案',
    duration: '25:50',
    views: '167万',
    badge: '持续追踪',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '爆料网的信息来源可靠吗？会不会是假瓜？',
    answer: '爆料网的内容来自多个渠道交叉验证，包括黑料网爆料、爆料黑料网、911爆料网吃瓜黑料等主流信源。我们的编辑团队会对每条黑料进行多方核验，标注信息来源和可信度等级。对于未经证实的信息，会明确标注「待核实」标签，绝不混淆视听。',
  },
  {
    id: 2,
    question: '爆料网每天什么时候更新内容？',
    answer: '我们保持每日至少两次固定更新：早上8点发布「早间黑料速递」汇总前夜至今晨的最新黑料；晚上8点发布「每日黑料合集」涵盖全天重点吃瓜黑料。此外，突发重大黑料曝光时，我们会随时加更，确保你第一时间获取独家内幕。',
  },
  {
    id: 3,
    question: '如何向爆料网投稿爆料？会保护我的隐私吗？',
    answer: '点击页面中的「联系我们」区域即可找到投稿方式。我们提供邮箱投稿和微信客服两种渠道。爆料网郑重承诺：对所有爆料人信息进行严格保密，投稿内容发表前均做匿名化处理，不保留任何可追溯至爆料人的个人信息。',
  },
  {
    id: 4,
    question: '爆料网和911爆料网是什么关系？',
    answer: '爆料网是独立运营的吃瓜黑料聚合平台，我们会引用包括911爆料网吃瓜黑料在内的多个信源内容，并注明出处。爆料网本身不生产黑料，而是做黑料汇总、整理和深度解读，帮助吃瓜群众更高效地获取和理清各类黑料信息。',
  },
  {
    id: 5,
    question: '为什么有些黑料看了一半就没了？',
    answer: '部分敏感黑料可能因涉及当事人维权、平台合规要求等原因被临时下架或调整。我们建议关注每日黑料合集中的归档版本，通常在汇总时会保留更多细节。同时也欢迎加入我们的社群，获取更即时的更新通知。',
  },
  {
    id: 6,
    question: '爆料网有APP吗？手机上怎么看？',
    answer: '爆料网目前为纯网页版，但移动端适配做得非常完善。在手机浏览器中访问体验与原生APP几乎一致。你可以将爆料网添加到手机主屏幕（iOS用Safari、Android用Chrome），即可像APP一样一键打开，方便快捷不占内存。',
  },
];

export const carouselItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20concept%20with%20abstract%20red%20and%20dark%20gradient%20texture%20editorial%20magazine%20style%20bold%20atmosphere%20cinematic&width=1200&height=600&seq=carousel-01&orientation=landscape',
    title: '2024年度黑料大盘点',
    subtitle: '十大震撼内幕一次性回顾',
    tag: '年度专题',
    desc: '从网红翻车到娱乐圈地震，今年最劲爆的黑料合集都在这里。',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=mysterious%20investigation%20scene%20dark%20amber%20lighting%20abstract%20dramatic%20texture%20editorial%20magazine%20aesthetic%20bold%20cinematic%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
    title: '直播圈黑料深度调查',
    subtitle: '揭开头部主播不为人知的另一面',
    tag: '深度调查',
    desc: '三个月暗访，独家揭露直播带货行业潜规则与内部黑料曝光。',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=social%20media%20scandal%20concept%20art%20dramatic%20red%20and%20dark%20abstract%20composition%20editorial%20style%20bold%20cinematic%20mood&width=1200&height=600&seq=carousel-03&orientation=landscape',
    title: '娱乐圈婚变内幕全记录',
    subtitle: '五对明星夫妻的真相追踪',
    tag: '独家追踪',
    desc: '从蛛丝马迹到实锤曝光，完整时间线还原娱乐圈婚变黑料。',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=digital%20investigation%20concept%20dark%20warm%20dramatic%20abstract%20texture%20editorial%20magazine%20style%20bold%20cinematic%20atmosphere%20modern&width=1200&height=600&seq=carousel-04&orientation=landscape',
    title: '资本博弈背后的黑料战争',
    subtitle: '巨头公司之间的暗战与真相',
    tag: '商业内幕',
    desc: '深入分析互联网大厂之间的明争暗斗与不为人知的黑料曝光。',
  },
];

export const indexItems = [
  { id: 1, title: '网红黑料大合集', count: 128, tag: '热门', desc: '最全网红翻车记录与黑料汇总' },
  { id: 2, title: '娱乐圈年度吃瓜', count: 96, tag: '推荐', desc: '年度最劲爆娱乐圈内幕整理' },
  { id: 3, title: '直播圈争议事件', count: 85, tag: '新', desc: '直播间里的那些不为人知' },
  { id: 4, title: '社会热点追踪', count: 112, tag: '热门', desc: '紧跟时事的社会黑料曝光' },
  { id: 5, title: '电竞圈八卦大全', count: 67, tag: '', desc: '电竞选手的那些爆料与内幕' },
  { id: 6, title: '偷税漏税黑名单', count: 43, tag: '重磅', desc: '知名人士税务问题全记录' },
  { id: 7, title: '情感纠纷吃瓜集', count: 156, tag: '热门', desc: '明星网红感情纠纷一网打尽' },
  { id: 8, title: '商业黑幕曝光台', count: 54, tag: '深度', desc: '企业背后的商业黑料内幕' },
  { id: 9, title: '每日黑料速览', count: 312, tag: '日更', desc: '每天最新鲜的黑料爆料汇总' },
];

export const cardItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=celebrity%20scandal%20concept%20dramatic%20warm%20lighting%20dark%20background%20editorial%20photography%20moody%20atmosphere%20red%20accents&width=600&height=400&seq=card-01&orientation=landscape',
    title: '独家：某知名艺人背后的资本链条大起底',
    excerpt: '深挖某当红艺人背后的商业版图，多家关联公司浮出水面，涉及金额令人咋舌……',
    time: '3小时前',
    category: '独家内幕',
    views: '56万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=internet%20celebrity%20controversy%20dramatic%20dark%20scene%20warm%20amber%20lighting%20editorial%20style%20moody%20atmosphere&width=600&height=400&seq=card-02&orientation=landscape',
    title: '某千万粉丝网红人设崩塌，前员工集体爆料内幕',
    excerpt: '多名前员工联合发声，揭露该网红私下真实面目与团队运作黑幕……',
    time: '6小时前',
    category: '网红黑料',
    views: '89万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=entertainment%20industry%20drama%20dark%20cinematic%20scene%20warm%20red%20lighting%20editorial%20photography%20dramatic%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    title: '某综艺节目录制内幕流出，导演组与嘉宾激烈冲突',
    excerpt: '节目录制现场不为人知的一幕，多位知情人士还原事件全貌……',
    time: '9小时前',
    category: '吃瓜黑料',
    views: '134万',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=dating%20scandal%20dark%20dramatic%20scene%20warm%20lighting%20editorial%20photography%20moody%20mysterious%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape',
    title: '某顶流情侣疑似分手，双方社交账号已互相取关',
    excerpt: '细心网友发现蛛丝马迹，多条线索指向两人关系已走到尽头……',
    time: '12小时前',
    category: '黑料曝光',
    views: '201万',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=business%20scandal%20concept%20dark%20dramatic%20warm%20lighting%20corporate%20atmosphere%20editorial%20style%20moody&width=600&height=400&seq=card-05&orientation=landscape',
    title: '某电商巨头内部反腐风暴，多名高管被带走调查',
    excerpt: '据知情人士透露，此次反腐行动涉及金额巨大，或牵出更多黑料……',
    time: '1天前',
    category: '黑料汇总',
    views: '312万',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=streaming%20platform%20controversy%20dark%20dramatic%20scene%20warm%20red%20lighting%20editorial%20photography%20moody%20mysterious&width=600&height=400&seq=card-06&orientation=landscape',
    title: '某知名主播被平台永久封禁，真实原因终于曝光',
    excerpt: '封禁背后隐藏的真相远比表面复杂，多个利益方卷入其中……',
    time: '2天前',
    category: '每日黑料',
    views: '178万',
  },
];

export const updateItems = [
  { id: 1, time: '10分钟前', title: '【快讯】某知名女星深夜发文疑似回应近期黑料传闻', tag: '最新' },
  { id: 2, time: '28分钟前', title: '【更新】网红黑料专题新增三段独家录音，信息量巨大', tag: '更新' },
  { id: 3, time: '1小时前', title: '【爆料】某电商平台内部人士透露即将有大瓜曝光', tag: '爆料' },
  { id: 4, time: '2小时前', title: '【追踪】昨日娱乐圈婚变事件又有新进展，第三方介入', tag: '追踪' },
  { id: 5, time: '3小时前', title: '【独家】911爆料网吃瓜黑料专题更新：新证据浮出水面', tag: '独家' },
  { id: 6, time: '5小时前', title: '【汇总】本周黑料合集已更新，五大重磅事件完整梳理', tag: '汇总' },
  { id: 7, time: '7小时前', title: '【热议】某选秀节目选手被曝年龄造假，粉丝集体脱粉', tag: '热议' },
  { id: 8, time: '9小时前', title: '【深挖】知名企业家私生活混乱，多段视频流传网络', tag: '深挖' },
  { id: 9, time: '12小时前', title: '【吃瓜】2024年最大翻车现场：某品牌代言人连环塌房', tag: '吃瓜' },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '全天候监控数百个信息源，黑料曝光后15分钟内完成核实与发布，确保吃瓜群众第一时间获取最新内幕。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '全面汇总',
    desc: '整合黑料网爆料、爆料黑料网、911爆料网吃瓜黑料等渠道，每日黑料合集帮你一站式掌握所有热门事件。',
  },
  {
    id: 3,
    icon: 'ri-shield-user-line',
    title: '隐私保护',
    desc: '所有爆料人信息严格保密，独家内幕发布前均做匿名化处理。我们以最高标准守护每一位信息提供者的安全。',
  },
];

export const partnerPlaceholder = [
  { name: '合作伙伴招募中' },
  { name: '商务合作联系' },
  { name: '友情链接交换' },
  { name: '媒体资源互换' },
  { name: '品牌联合推广' },
];